import {useToken} from "@chakra-ui/react";
import {useMemo} from "react";

export const COLOR_PALETTES = [
  "gray",
  "red",
  "pink",
  "purple",
  "cyan",
  "blue",
  "teal",
  "green",
  "yellow",
  "orange",
] as const;

/** A subset of Chakra 3's color palettes suitable for use in the data flow diagram. */
export type ColorPalette = (typeof COLOR_PALETTES)[number];

export function useResolvedColorPalettes(): Record<ColorPalette, string> {
  const resolvedColors = useToken(
    "colors",
    COLOR_PALETTES.map(p => `${p}.500`),
  );

  return useMemo(() => {
    return resolvedColors.reduce(
      (acc, color, index) => ({...acc, [COLOR_PALETTES[index]]: color}),
      {} as Record<ColorPalette, string>,
    );
  }, [resolvedColors]);
}
